module.exports = __webpack_public_path__ + "media/bootstrap-icons/trash2-832ad426.svg";